import { finalize } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { ParametreDocumentStateService } from './parametre-document-state.service';
import { VenteAchatParametreRow } from './parametre-document-settings.service';

/**
 * Enregistrement PUT : merge une ligne `vente_achat` + envoi du bundle complet (station + toutes les lignes).
 */
export function saveParametreDocTypeRow(
    state: ParametreDocumentStateService,
    toastr: ToastrService,
    typeDocumentId: number,
    category: 'vente' | 'achat',
    patch: Partial<VenteAchatParametreRow>,
    setSaving: (v: boolean) => void
): void {
    setSaving(true);
    state
        .saveWithVenteAchatPatch(typeDocumentId, category, patch)
        .pipe(finalize(() => setSaving(false)))
        .subscribe({
            next: () => toastr.success('Paramètres enregistrés.', 'Succès'),
            error: (err) => {
                const msg = err?.error?.message ?? err?.message ?? 'Erreur serveur';
                toastr.error(msg, 'Enregistrement');
            }
        });
}
